import { render, staticRenderFns } from "./setting-skill.vue?vue&type=template&id=3d7d37fc&scoped=true&"
import script from "./setting-skill.vue?vue&type=script&lang=js&"
export * from "./setting-skill.vue?vue&type=script&lang=js&"
import style0 from "./setting-skill.vue?vue&type=style&index=0&id=3d7d37fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d37fc",
  null
  
)

export default component.exports